import $ from 'jquery';
import { calculators } from '../../common/js/calculator';
import CONSTANT from '../../common/js/_constant';
import formHandler from '../genericForm/_genericForm';
import { load } from 'recaptcha-v3';
import AirDatepicker from 'air-datepicker';
import localEn from 'air-datepicker/locale/en';

const oneByOne = {
    variables : {
        oboFormSubmit : ".one-by-one__form",
        oboPrevButton : ".one-by-one__buttons--prev",
        oboNextButton : ".one-by-one__buttons--next",
        oboStartButton:".one-by-one__buttons--started",
        age:'',
        minAge:'',
        maxAge:'',
        name: '',
        email: '',
        dob: '',
        countryCode: '',
        mobileNo: '',
        productCategory:'',
        productName:'',
        servletID: '',
        leadId: '',
        annualIncome: '',
        siteKey : "6LcW0h8qAAAAAO2QgLupJ0tglgpVbguVB3-IxXIp"
    },
    methods : {
        handleButtonClick:(el)=>{
            const $el = $(el);
            const {oboFormSubmit,oboPrevButton, oboNextButton, oboStartButton} = oneByOne.variables;
            const consentCheckbox = $el.find('.one-by-one__consent--input');
            $el.find(oboNextButton).on(CONSTANT.eventsListners.CLICK,function(e){
                e.preventDefault();
                const inputs = $el.find('.one-by-one--details.active').find('input');
                $(inputs).each(function(){
                    if($(this).prop('required') && $(this).val() == ''){
                        if(!$(this).hasClass('one-by-one__consent--input')){
                            $(this).addClass('border-red-300');
                            $(this).siblings('.invalid-error').addClass('opacity-0');
                            $(this).siblings('.empty-error').removeClass('opacity-0');
                        }
                    }
                })
               
                if(consentCheckbox.prop('required') && !consentCheckbox.is(':checked')){
                    consentCheckbox.removeClass('border-blue-400').addClass('border-red-300').removeClass('checked');
                }
                oneByOne.methods.handlePrevNextDataLayer(el,'Next',$el.find('.one-by-one--details.active').find('.one-by-one__group--label')[0]);
                const isError = $el.find('.one-by-one--details.active').find('.border-red-300');
                if(isError.length) {return;}
                const isBack = calculators.methods.handleNextPrev(el,false);
                if(isBack){
                    $el.find(oboPrevButton).removeClass('d-none');
                }
                else{
                  $el.find(oboNextButton).addClass('d-none');
                  $el.find(oboStartButton).removeClass('d-none');
                }
            });
            $el.find(oboPrevButton).on(CONSTANT.eventsListners.CLICK,function(){
                oneByOne.methods.handlePrevNextDataLayer(el, 'Back',$el.find('.one-by-one--details.active').find('.one-by-one__group--label')[0]);
                const isBack = calculators.methods.handleNextPrev(el,true);
                $el.find(oboNextButton).removeClass('d-none');
                $el.find(oboStartButton).addClass('d-none');
                if(isBack){
                    $el.find(oboPrevButton).removeClass('d-none');
                }
                else{
                    $el.find(oboPrevButton).addClass('d-none');
                }
            });
            $el.find(oboStartButton).on(CONSTANT.eventsListners.CLICK,(e)=>{
                const minValue = $(el).find('.one-by-one__select--option').data('min-income');
                const optionSelected = $(el).find('.one-by-one__option');
                $(optionSelected).each(function(){
                    if($(this).hasClass('selected')){
                        if(minValue > $(this).data('value')){
                            $(el).find('.one-by-one__select--error').removeClass('opacity-0');
                        }else{
                            $(el).find('.one-by-one__select--error').addClass('opacity-0');
                        }
                    }
                });
                const isError = $el.find('.one-by-one--details.active').find('.one-by-one__select--error').hasClass('opacity-0');
                if(!isError) {return;}
                oneByOne.methods.handleSubmitForm(el);
            })
        },
        resetForm : (el)=>{
            const $el = $(el);
            const {oboFormSubmit,oboPrevButton, oboNextButton, oboStartButton} = oneByOne.variables;
            $el.find('.one-by-one--details').removeClass('active');
            $($el.find('.one-by-one--details')[0]).addClass('active');
            $el.find('.one-by-one--details').each(function(){
                $(this).find('input').val('');
            })
            $el.find('.one-by-one__consent--input').prop("checked", false);
            $el.find('.one-by-one__consent--input').removeClass('border-red-300');
            $el.find('.one-by-one__option').removeClass('selected');
            $($el.find('.one-by-one__option')[0]).addClass('selected');
            $el.find(oboNextButton).removeClass('d-none');
            $el.find(oboStartButton).addClass('d-none');
            $el.find(oboPrevButton).addClass('d-none');
        },
        backToForm: function(ele){
            const backBtn = $(ele).find('.one-by-one__back');
            backBtn.each(function(){
                $(this).on('click', () => {
                    $(this).closest('.one-by-one').find('.form-error').addClass('d-none');
                    const formContainer = $(this).closest('.one-by-one').find('.one-by-one__wrapper--questions');
                    formContainer.removeClass('d-none');
                });
            });
        },
        handleLoader(loader, isAdd){
            const parentLoad = $(loader).find('.spinning-loader');
            if(isAdd){
                $('body').append(parentLoad); // Move the loader to the body
                $(parentLoad).removeClass('d-none').addClass('inside-body-loader'); // Show the loader
                $('body').css('overflow', 'hidden'); // Prevent body scrolling
            }else{
                $('body').css('overflow', ''); // Restore body scrolling
                const loaderBody = $('body').find('.inside-body-loader');
                $(loader).append($(loaderBody).removeClass('inside-body-loader').addClass('d-none'));
            }
        },
        handleSubmitForm :(el)=>{
            const $el = $(el);
            const {oboFormSubmit} = oneByOne.variables;
            const form = $el.find(oboFormSubmit);
            const formContainer = $(form).closest('.one-by-one').find('.one-by-one__wrapper--questions');
            const optionSelectedValue = $(form).find('.one-by-one__option.selected').data('value');
            const consentCheckbox = $(el).find('.one-by-one__consent--input');
            oneByOne.methods.handleLoader(el, true);
            load(oneByOne.variables.siteKey).then(recaptcha=>{
                recaptcha.execute('submit').then(token=>{
                    const servletID =  $(form).data('servlet-id');
                    const url = `/bin/chli/genericForm?servletID=${servletID}`;
                    let json = formHandler.methods.convertFormToJSON(form);
                    json['annualIncome'] = optionSelectedValue;
                    oneByOne.variables.name = json["fullName"];
                    oneByOne.variables.email = json["emailID"];
                    oneByOne.variables.dob = json["dob"];
                    oneByOne.variables.countryCode = json["countryCode"];
                    oneByOne.variables.mobileNo = json["mobileNumber"];
                    oneByOne.variables.productCategory = json["productCategory"];
                    oneByOne.variables.productName = json["productName"];
                    oneByOne.variables.servletID = servletID;
                    oneByOne.variables.annualIncome = optionSelectedValue;

                    if($(form).data('recaptcha')){
                        json['g-recaptcha-response'] = token;
                    }
                    json['leadConsent']= (consentCheckbox && consentCheckbox.is(':checked'))? 'Yes': 'No';
                    json['gaId'] = getClientId();
                    json = JSON.stringify(json);
                    $.ajax({
                        type: "POST",
                        url: url,
                        data: json,
                        contentType: "application/json",
                        dataType: "json",
                    }).done((response) => {
                        oneByOne.methods.handleLoader(el, false);
                    if(servletID == "digital"){
                        oneByOne.methods.redirectionForm(form);
                        oneByOne.variables.leadId = response.leadId;
                        oneByOne.methods.getStartedButtonClickHandler($(this));
                        formContainer.removeClass('d-none');
                    }else if(servletID == "dst"){
                            oneByOne.methods.dstSubmission(form);
                            oneByOne.variables.leadId = response.leadId;
                            oneByOne.methods.getStartedButtonClickHandler($(this));
                        formContainer.removeClass('d-none');
                    }
                    }).catch((error) => {
                        console.error(error);
                        oneByOne.methods.handleLoader(el, false);
                        const errorContainer = $el.find('.form-error');
                        errorContainer.removeClass('d-none');
                        formContainer.addClass('d-none');
                    });
                })
            }).catch(err=>{
                oneByOne.methods.handleLoader(el, true);
                console.log(err);
            });
        },
        dstSubmission: function(form){
            const parentContainer = form.closest('.one-by-one');
            const dstResponseContainer = parentContainer.find('.dst-submission');
            dstResponseContainer.removeClass('d-none');
            $('body').addClass('overflow-hidden');
            $('body').append(dstResponseContainer); 
            $(dstResponseContainer).removeClass('d-none').addClass('inside-body-onedstThankyou'); 
            oneByOne.methods.resetForm(parentContainer);
        },
        redirectionForm: function(form){
             const url = $(form).find('.one-by-one__redirect').data('url');
             const target = $(form).find('.one-by-one__redirect').data('target');
             if(url){
              window.open(url,target);
             }
         },
         readMore: function(el){
            const readMoreBtn = $(el).find('.one-by-one__consent--expand');
            const readLessBtn = $(el).find('.one-by-one__consent--compress');
            readMoreBtn.each(function(){
                if($(this).parent().height() > 15){
                    $(this).removeClass('d-none');
                    $(this).parent().addClass('expanded-false');
                }
                $(this).on('click', function(){
                    $(this).parent().addClass('expanded').removeClass('expanded-false');
                    $(this).addClass('d-none');
                    readLessBtn.removeClass('d-none');
                });
                readLessBtn.on('click',function(){
                    $(this).parent().removeClass('expanded').addClass('expanded-false');
                    $(this).addClass('d-none');
                    readMoreBtn.removeClass('d-none');
                })
            });
         },
         closeDSTResponse: function(ele){
            const closeContainer = $('.one-by-one .dst-submission__close');
            closeContainer.each(function(){
                 $(this).on('click', function(){
                     $(this).closest('.dst-submission').addClass('d-none');
                     $('body').removeClass('overflow-hidden');
                     const loaderBody = $('body').find('.inside-body-onedstThankyou');
                     $(ele).append($(loaderBody).removeClass('inside-body-onedstThankyou').addClass('d-none'));
                 });
            });
            const closeIcon = $('.one-by-one .close-icon');
            closeIcon.each(function(){
                 $(this).on('click', function(){
                     $(this).closest('.dst-submission').addClass('d-none');
                     $('body').removeClass('overflow-hidden');
                     const loaderBody = $('body').find('.inside-body-onedstThankyou');
                     $(ele).append($(loaderBody).removeClass('inside-body-onedstThankyou').addClass('d-none'));
                 });
            });
        },
        calculateAge: function(ele){
            const dateInputs = $(ele).find('.one-by-one__group--input[name="dob"]');
            dateInputs.each(function() {
                $(this).on('change', function() {
                    let age = new Date().getFullYear() - new Date($(this).val()).getFullYear();
                    let minAge = dateInputs.data('minage');
                    let maxAge = dateInputs.data('maxage');
                    const monthDifference = new Date().getMonth() - new Date($(this).val()).getMonth(),
                    dayDifference = new Date().getDate() - new Date($(this).val()).getDate();
                    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
                        age--;
                    }
                    oneByOne.variables.age = age;
                    oneByOne.variables.minAge = minAge;
                    oneByOne.variables.maxAge = maxAge;
                    const ageContainer = $(this).siblings('.one-by-one__group--age');
                    if((age && minAge && maxAge) && (age<minAge || age>maxAge) || (new Date().getFullYear() < (new Date($(this).val()).getFullYear()+1))){
                        $(this).addClass('border-red-300').removeClass('border-transparent');
                        $(this).siblings('.invalid-error').removeClass('opacity-0');
                        ageContainer.removeClass('text-blue-400').addClass('text-red-300');
                    }else{
                        $(this).removeClass('border-red-300').addClass('border-transparent');
                        $(this).siblings('.invalid-error').addClass('opacity-0');
                        ageContainer.addClass('text-blue-400').removeClass('text-red-300');
                    }
                    const ageText = age + " " + ageContainer.data('suffix');
                    if(age){
                     ageContainer.text(ageText);
                    }
                    else{
                     ageContainer.text("");
                    }
                });
            });
        },
        validateInput: function(ele){
            const inputs = $(ele).find('.one-by-one__group--input');
            const consentCheckbox = $(ele).find('.one-by-one__consent--input');
            inputs.each(function(){
                $(this).on(CONSTANT.eventsListners.INPUT, function(){
                    $(this).siblings('.empty-error').addClass('opacity-0');
                    $(this).removeClass('border-red-300');
                    const regex = new RegExp($(this).data('regex'));
                    if(regex){
                        if(regex.test($(this).val())){
                            $(this).siblings('.invalid-error').addClass('opacity-0');
                            $(this).removeClass('border-red-300');
                        }else{
                            $(this).siblings('.invalid-error').removeClass('opacity-0');
                            $(this).addClass('border-red-300');
                        }
                    }
                    if($(this).prop('required') && $(this).val() == ''){
                        $(this).addClass('border-red-300');
                        $(this).siblings('.invalid-error').addClass('opacity-0');
                        $(this).siblings('.empty-error').removeClass('opacity-0');
                    }
                });
            });
            $(consentCheckbox).on(CONSTANT.eventsListners.CHANGE,function(){
                if(consentCheckbox.prop('required') && !consentCheckbox.is(':checked')){
                    $(consentCheckbox).addClass('border-red-300').removeClass('checked');
                }else{
                    $(consentCheckbox).removeClass('border-red-300').addClass('checked');
                }
            })
        },
        handleSelection :(ele)=>{
            $($(ele).find(".one-by-one__option")[0]).addClass("selected");
            const minValue = $(ele).find('.one-by-one__select--option').data('min-income');
            $(ele).find(".one-by-one__option").each(function(){
                $(this).on(CONSTANT.eventsListners.CLICK,(e)=>{
                    $(ele).find(".one-by-one__option").removeClass("selected");
                    $(this).addClass("selected");
                    if(minValue > $(this).data('value')){
                        $(ele).find('.one-by-one__select--error').removeClass('opacity-0').addClass('border-red-300');
                    }else{
                        $(ele).find('.one-by-one__select--error').addClass('opacity-0').removeClass('border-red-300');
                    }
                })
            })
        },
        init :()=>{
            $('.one-by-one').each((idx,ele)=>{
                oneByOne.methods.handleButtonClick(ele);
                oneByOne.methods.validateInput(ele);
                oneByOne.methods.calculateAge(ele);
                oneByOne.methods.handleSelection(ele);
                oneByOne.methods.closeDSTResponse(ele);
                oneByOne.methods.backToForm(ele);
                oneByOne.methods.readMore(ele);

                new AirDatepicker('.generic-form-dob', {
                    dateFormat: 'yyyy-MM-dd',
                    isMobile: window.matchMedia("(max-width: 768px)").matches,
                    maxDate: $('.generic-form-dob').prop('max'),
                    autoClose: true,
                    locale: localEn,
                    onSelect({ date }) {
                        if (date) {
                            const today = new Date();
                            const selectedDate = new Date(date);
                            const yearsDifference = today.getFullYear() - selectedDate.getFullYear();
                            const isBeforeBirthday = (
                                today.getMonth() < selectedDate.getMonth() ||
                                (today.getMonth() === selectedDate.getMonth() && today.getDate() < selectedDate.getDate())
                            );
                            const age = isBeforeBirthday ? yearsDifference - 1 : yearsDifference;
                           $('.one-by-one__group--age')
                           .text(`${age} years`)
                           .removeClass('text-red-300') 
                           .addClass('text-blue-400');   
                            $('.age-display').text(`Age: ${age}`);
                        $('.generic-form-dob').removeClass('border-red-300');
                        $('.one-by-one__group--error').addClass('opacity-0');
                        }
                    }
                });
            })
        },
        handlePrevNextDataLayer : function(element, buttonText, inputLabel){
            let titleText = $(element).find('.one-by-one__wrapper--title').text().trim();
            let obj = oneByOne.methods.dataLayerObj(buttonText,titleText + '_'+ $(inputLabel).data('text').trim());
            createDataLayer('buttonClick',obj);
        },
        getStartedButtonClickHandler: function(element){
              let buttonText = element.find('.one-by-one__buttons--started').text().replace(/\s+/g, ' ').trim();
              let container = element.closest('.one-by-one__wrapper');
              let titleText = container.find('.one-by-one__wrapper--title').text().trim();
              let obj = oneByOne.methods.dataLayerObj(buttonText,titleText);
              createDataLayer('LeadSubmitted',obj);
        },
        getStartedButtonClickHandler: function(element){
                      let buttonText = element.find('.one-by-one__buttons--started').text().replace(/\s+/g, ' ').trim();
                      let container = element.closest('.one-by-one__wrapper');
                      let titleText = container.find('.one-by-one__wrapper--title').text().trim();
                      let obj = oneByOne.methods.dataLayerObj(buttonText,titleText);
                      createDataLayer('LeadSubmitted',obj);
                },

        dataLayerObj: function (el,e) {
            var obj = {
                 'articleName': "",
                 'blogCategory': "",
                 'blogPageCategory': "",
                 'buttonText': el ? el : "Get Started",
                 'pageSection': e ? e : "One by one Form Component",
                 'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.lastIndexOf('/')) === ".com" ? "Home" : "Other Pages" : "Blog Details Page",
                 'planOption': "",
                 'productCategory': oneByOne.variables.productCategory ? oneByOne.variables.productCategory : "",
                 'productName': oneByOne.variables.productName ? oneByOne.variables.productName : "",
                 'question': "",
                 'source': "",
                 'leadForm': oneByOne.variables.servletID ? oneByOne.variables.servletID : "",
                 'name': oneByOne.variables.name ? oneByOne.variables.name : "",
                 'email': oneByOne.variables.email ? oneByOne.variables.email : "",
                 'dob': oneByOne.variables.dob ? oneByOne.variables.dob : "",
                 'countryCode': oneByOne.variables.countryCode ? oneByOne.variables.countryCode : "",
                 'mobileNumber': oneByOne.variables.mobileNo ? oneByOne.variables.mobileNo : "",
                 'annualIncome': oneByOne.variables.annualIncome ? oneByOne.variables.annualIncome : "",
                 'leadId' : oneByOne.variables.leadId ? oneByOne.variables.leadId : "",
                 'searchTerm': "",
                 'videoTitle': "",
                 'bannerName': "",
              };
            return obj;
        }
    }
}

$(()=>{
    if($('.one-by-one').length > 0){
        oneByOne.methods.init();
    }
})